module.exports = __webpack_public_path__ + "static/media/electricity-icon.c86bd1f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Icons/electricity-icon.svg
// module id = 705
// module chunks = 0